/**
 * Componente para proteger rotas que exigem autenticação
 */

import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import LoadingSpinner from './ui/LoadingSpinner'

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth()
  const location = useLocation()

  // Mostrar loading enquanto verifica autenticação
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  // Se não estiver autenticado, redirecionar para login
  const authed = !!isAuthenticated;
  
  if (!authed) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // Se estiver autenticado, renderizar o componente
  return children
}

export default ProtectedRoute


